import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Community from "./pages/Community";
import Auth from "./pages/Auth";
import RichPage from "./components/RichPage";
import Profile from "./pages/Profile";
import StatePrisons from "./pages/StatePrisons";
import LegalPage from "./pages/LegalPage";
import { PaymentSuccess, PaymentCancel, DonationThankYou } from "./pages/Payment";
import AdminAnnounce from "./pages/AdminAnnounce";

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <main className="relative z-10 min-h-[60vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/community" element={<Community />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/my-story" element={<Navigate to="/" replace />} />
              <Route path="/prisons-qld" element={<Navigate to="/prisons/qld" replace />} />
              <Route path="/prisons/:state" element={<StatePrisons />} />
              <Route path="/u/:username" element={<Profile />} />
              <Route path="/privacy-policy" element={<LegalPage />} />
              <Route path="/disclaimer" element={<LegalPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/donation/thank-you" element={<DonationThankYou />} />
              <Route path="/admin/announce" element={<AdminAnnounce />} />
              <Route path="/:slug" element={<RichPage />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
